"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetInitialAlarmData = void 0;
var _react = require("react");
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _devices = require("../redux/actions/devices");
var _actions = require("../redux/actions");
var _constants = require("../utils/constants");
const useSetInitialAlarmData = _ref => {
  let {
    chartId,
    alarmItem,
    rangeParams,
    equipmentKeyIsPwh,
    equipment
  } = _ref;
  const firstEffect = (0, _react.useRef)(true);
  const firstEffect2 = (0, _react.useRef)(true);
  const dispatch = (0, _reactRedux.useDispatch)();
  const coreDevices = (0, _reactRedux.useSelector)(store => {
    var _store$constants$pack;
    return ((_store$constants$pack = store[_paulCorePackage.constants.packageKey]) === null || _store$constants$pack === void 0 ? void 0 : _store$constants$pack.devices) || {};
  });
  (0, _react.useEffect)(() => {
    if (alarmItem) dispatch((0, _devices.setAlarmItemAction)({
      chartId,
      alarmItem
    }));
  }, [dispatch, alarmItem, chartId]);
  (0, _react.useEffect)(() => {
    if (!firstEffect.current || !(coreDevices !== null && coreDevices !== void 0 && coreDevices.hasData)) return;
    firstEffect.current = false;
    dispatch((0, _devices.setInitialDeviceData)({
      result: coreDevices
    }));
    if (!_paulCorePackage.functions.isEmpty(rangeParams)) {
      dispatch((0, _actions.setChartParamsList)({
        chartId,
        params: rangeParams
      }));
    }
  }, [dispatch, coreDevices, rangeParams, equipmentKeyIsPwh, chartId]);

  /** @todo maybe we can remove firstEffect2.current */
  (0, _react.useEffect)(() => {
    if (!firstEffect2.current || !equipment) return;
    firstEffect2.current = false;
    dispatch((0, _devices.setActiveGroup)({
      chartId,
      equipmentKey: equipmentKeyIsPwh ? _constants.keysForGroupChartsById.Pwh : _constants.keysForGroupChartsById.Htg,
      group: equipment
    }));
  }, [dispatch, equipment, chartId, equipmentKeyIsPwh]);
};
exports.useSetInitialAlarmData = useSetInitialAlarmData;